import client from './client';

export default (function TagsService() {
  let service;

  if (!service) {
    service = client.service('tags');
  }

  return service;
}());
